import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environment/environment';

@Injectable({
  providedIn: 'root',
})
export class PosterService {
  constructor(private http: HttpClient) {}

  createPoster(data: any): Observable<any> {
    return this.http.post(`${environment.authUrl}/posters`, data);
  }

  getPosters(langCode: any, searchTerm: string = ''): Observable<any> {
    return this.http.get(`${environment.authUrl}/posters/admin`, {
      headers: { lang: langCode },
      params: { searchTerm }
    });
  }

  deletePoster(id: number): Observable<any> {
    return this.http.delete(`${environment.authUrl}/posters/${id}`);
  }

  getPosterById(id: number, langCode: any): Observable<any> {
    return this.http.get(`${environment.authUrl}/posters/admin/fetchOne/${id}`, {
      headers: { lang: langCode },
    });
  }

  updatePoster(data: any): Observable<any> {
    return this.http.patch(`${environment.authUrl}/posters/updatePoster`, data);
  }


  addNewTraslation(data: any): Observable<any> {
    return this.http.post(`${environment.authUrl}/posters/addTranslation`, data);
  }

  deletePosterTranslation(id: number): Observable<any>{
    return this.http.delete(`${environment.authUrl}/posters/deletetranslation/${id}`)
  }
}
